import hasSmoothScroll from "./hasSmoothScroll";
import mirrorScrollLeft from "./mirrorScrollLeft";
const setElementScroll = (el, scrollValue, options = { instant: false }) => {
    const { instant } = options;
    const denormalizedValue = mirrorScrollLeft(el, scrollValue);
    const supportsSmoothScrolling = hasSmoothScroll();
    if (!supportsSmoothScrolling) {
        /* eslint-disable-next-line no-param-reassign */
        el.scrollLeft = denormalizedValue;
    }
    else {
        el.scrollTo({
            left: denormalizedValue,
            behavior: !instant ? "smooth" : undefined,
        });
    }
};
export default setElementScroll;
